module.exports = require('use-memo-one')
